(() => {
  const STEPS_WORD = "Steps";
  const INGREDIENTS_WORD = "Ingredients";

  const fractionSlash = "\\u2044"; // fraction slash
  const vulgarFractions = `\\u00BC-\\u00BE\\u2150-\\u215E`;
  const isFraction = new RegExp(`[${vulgarFractions}]|\\d+ ?\\/ ?\\d+`);
  const isVulgarFraction = new RegExp(`[${vulgarFractions}]`);
  const regex = {
    ingredientDeclaration: (name, flags) =>
      new RegExp(
        `(?<prefix>Zest of )?(?<qty>\\d*[${vulgarFractions}]?|\\d+ ?\\/ ?\\d+|\\d+\\.?\\d*)(\\s*(?<unit>box|lb|cup|cups|tsp|tbsp|oz))?\\s+(?<name>${
          name || ".*"
        })`,
        flags || "i"
      ),
    ingredientReference: (name, flags) =>
      new RegExp(
        `(?<prefix>Zest of )?\\[((?<qty>\\d*[${vulgarFractions}]?|\\d+ ?\\/ ?\\d+|\\d+\\.?\\d*)(\\s*(?<unit>box|lb|cup|cups|tsp|tbsp|oz))?)?(?<name>${
          name || ".*"
        })\\]`,
        flags || "i"
      ),
  };

  function fracToNumber(str) {
    if (!str) return str;
    if (str.indexOf("/") > -1) {
      const [num, den] = str.split("/").map((s) => Number(s.trim()));
      return num / den;
    } else if (isVulgarFraction.test(str)) {
      const vulgarFractions = {
        "¼": 0.25,
        "½": 0.5,
        "¾": 0.75,
        "⅐": 0.142857,
        "⅑": 0.111111,
        "⅒": 0.1,
        "⅓": 0.333333,
        "⅔": 0.666667,
        "⅕": 0.2,
        "⅖": 0.4,
        "⅗": 0.6,
        "⅘": 0.8,
        "⅙": 0.166667,
        "⅚": 0.833333,
        "⅛": 0.125,
        "⅜": 0.375,
        "⅝": 0.625,
        "⅞": 0.875,
      };
      return vulgarFractions[str];
    }
    console.warn("fracToNumber: no fraction found in string", `'${str}'`);
    return str;
  }

  function servingsChooser(parent) {
    const paras = [...parent.querySelectorAll("p")];
    const hasServingsPattern = /Serves/;
    const pattern = /(Serves\s*:?\s*)(\d+)/;
    const pText = (p) => p.innerText.replace("\u200B", "");
    const servs = paras.find((p) => hasServingsPattern.test(pText(p)));
    if (!servs) return null;
    const originalValue = servs.innerText;
    const defaultServingsMatch = pattern.exec(pText(servs));
    const div = document.createElement("div");
    div.className = "sk-servings";
    div.appendChild(servs);
    if (defaultServingsMatch) {
      // create injection point
      servs.innerHTML = originalValue.replace(
        pattern,
        `<div class="sk-servings-group">
          <div class="sk-servings-control"></div>
          <a class="print-preview-button">Print Preview</a>
        </div>`
      );
      const control = servs.querySelector(".sk-servings-control");
      // const control = document.createElement("div");
      // control.className  = "sk-servings-control";
      const defaultServings = Number(defaultServingsMatch[2]);
      const btnLess = document.createElement("a");
      btnLess.className = "ph ph-minus";
      btnLess.addEventListener("click", (e) => {
        const val = Number(input.value);
        input.value = Math.max(1, val - 1);
        const changeEvent = new Event("change", { bubbles: true });
        input.dispatchEvent(changeEvent);
      });
      const btnMore = document.createElement("a");
      btnMore.className = "ph ph-plus";
      btnMore.addEventListener("click", (e) => {
        const val = Number(input.value);
        input.value = Math.max(1, val + 1);
        const changeEvent = new Event("change", { bubbles: true });
        input.dispatchEvent(changeEvent);
      });
      const input = document.createElement("input");
      input.type = "text";
      input.value = defaultServings;
      control.appendChild(btnLess);
      const label = document.createElement("span");
      label.className = "sk-servings-label";
      label.innerText = "Servings";
      control.appendChild(label);
      control.appendChild(input);
      control.appendChild(btnMore);
      input.addEventListener(
        "change",
        debounce((e) => {
          const allQuantities = document.querySelectorAll(".sk-qty");
          allQuantities.forEach((qty) => {
            const originalValue = qty.getAttribute("data-original-value");
            if (e.target.value === defaultServings) {
              qty.innerText = originalValue;
            } else {
              const numOriginalValue = isFraction.test(originalValue)
                ? fracToNumber(originalValue)
                : Number(originalValue);
              const newVal =
                (numOriginalValue * e.target.value) / defaultServings;
              qty.innerText =
                newVal.toString().indexOf(".") > -1
                  ? newVal.toFixed(1)
                  : newVal;
            }
          });
        }, 100)
      );
    } else {
      div.innerHTML += '<a class="print-preview-button">Print Preview</a>';
    }
    const ppreview = div.querySelector(".print-preview-button");
    if (ppreview) {
      ppreview.addEventListener("click", (e) => {
        document.querySelector('html').classList.toggle('print-preview');
      });
    }
    return div;
  }

  function heroVideo(parent) {
    if (!parent) return null;
    const videos = [...parent.querySelectorAll("figure")];
    const video = videos[0];
    if (!video) return null;
    const videoEl = video.querySelector("video");
    if (videoEl && videoEl.muted && videoEl.autoplay) {
      videoEl.controls = true;
      const overlay = video.querySelector(".kg-video-overlay");
      overlay.style.pointerEvents = "none";
    }
    return video;
  }

  function splitSections(elements, headingLevel = "H3") {
    const sections = [];
    let section = [];
    elements.forEach((el) => {
      if (el.tagName === headingLevel && !!el.innerHTML.trim()) {
        if (section.length) sections.push(section);
        section = [el];
      } else {
        section.push(el);
      }
    });
    if (section.length) sections.push(section);
    return sections;
  }

  function getHeadingIndex(elements, headingTitle, headingLevel = "H2") {
    return elements.findIndex(
      (el) =>
        el.tagName === headingLevel &&
        el.innerText.toLowerCase().slice(0, headingTitle.length) ===
          headingTitle.toLowerCase()
    );
  }
  
  function extractHeading(parent, headingTitle, headingLevel = "H2") {
    const children = Array.isArray(parent) ? parent : [...parent.children];
    const idxHeading = getHeadingIndex(children, headingTitle, headingLevel);
    return children[idxHeading];
  }

  function extractSection(parent, headingTitle, headingLevel = "H2") {
    const children = Array.isArray(parent) ? parent : [...parent.children];
    const idxHeading = getHeadingIndex(children, headingTitle, headingLevel);
    const nextHeading = children
      .slice(idxHeading + 1)
      .findIndex((child) => child.tagName === headingLevel);
    const slice = children.slice(
      idxHeading,
      nextHeading >= 0 ? idxHeading + nextHeading + 1 : undefined
    );
    return slice;
  }

  function extractSections(parent, headingTitle, headingLevel = "H2") {
    // use extractSection() to get an array of all matching sections in the parent
    const sections = [];
    let children = [...parent.children];
    while (children.length) {
      const section = extractSection(children, headingTitle, headingLevel);
      if (section.length) {
        sections.push(section);
        children = children.slice(
          children.indexOf(section[section.length - 1]) + 1
        );
      } else {
        break;
      }
    }
    return sections;
  }

  function parseIngredientName(ingredient) {
    const rx = /.*(\[(.+)\]).*/i;
    const roundBrackets = /\(.*\)/gi;
    const squareBrackets = /\[|\]/gi;
    const match = rx.exec(ingredient);
    if (!match)
      return {
        name: ingredient.replace(squareBrackets, ""),
        key: ingredient.replace(roundBrackets, "").trim(),
      };
    const [_, __, key] = match;
    const name = ingredient
      .replace(roundBrackets, "")
      .trim()
      .replace(squareBrackets, "");
    return { name, key: key.replace(roundBrackets, "").trim() };
  }

  function listToTable(el, ingredients) {
    const div = document.createElement("div");
    div.className = "sk-ingredients-table";
    const items = [...el.querySelectorAll("li")];
    const pattern = regex.ingredientDeclaration();
    div.innerHTML = `
    <table>
      <tbody>
        ${items
          .map((item) => {
            const { qty, unit, name, prefix } =
              pattern.exec(item.innerHTML)?.groups || {};
            if (!name) return "";
            const { key, name: cleanName } = parseIngredientName(name);
            if (ingredients) ingredients[key] = [qty, unit];
            return `<tr>
                      <td>
                        <span class="sk-qty" data-original-value="${qty}">${prefix ? prefix + ' ' : ''}${qty}</span>
                        ${unit ? `<span class="sk-unit">${unit}</span>` : ""}
                      </td>
                      <td>
                        <span class="sk-ingredient-name">${cleanName}</span>
                      </td>
                    </tr>`;
          })
          .join("\n")}
      </tbody>
    </table>
    `;
    div.querySelectorAll("a").forEach((a) => { a.setAttribute('target', '_blank'); });
    return div;
  }

  function ingredientsTable(parent) {
    const elements = extractSection(parent, INGREDIENTS_WORD);
    const ingredients = {};
    const converted = elements.map((el) => {
      if (el.tagName === "UL") {
        const div = listToTable(el, ingredients);
        el.parentNode.removeChild(el);
        return div;
      } else {
        return el;
      }
    });
    return { elements: converted, ingredients };
  }

  function ingredientsInContent(content) {
    if (!content) return;
    const children = [...content.querySelectorAll("ul")];
    children.forEach((ul) => {
      const table = listToTable(ul);
      ul.parentNode.insertBefore(table, ul);
      ul.parentNode.removeChild(ul);
    });
  }

  function stepsGroup(elements) {
    if (!elements.length) return { element: null, nextSibling: null };
    const last = elements[elements.length - 1];
    const nextSibling = last.nextSibling;
    const sections = splitSections(elements, "H3");
    const formattedSections = sections.map((section) => {
      const figure = section.find((el) => el.tagName === "FIGURE");
      const idx = figure ? section.indexOf(figure) : -1;
      const [fig] = figure ? section.splice(idx, 1) : [];
      const div = document.createElement("div");
      div.className = "sk-instruction-step";
      const content = document.createElement("div");
      content.className = "sk-instruction-step-content";
      const heading = section.find((el) => el.tagName === "H3");
      if (heading) {
        const smallScreenH3 = heading.cloneNode(true);
        smallScreenH3.classList.add("sk-small-screen");
        div.appendChild(smallScreenH3);
      }
      if (fig) {
        div.appendChild(fig);
      } else {
        const fig = document.createElement("figure");
        fig.className = "empty";
        div.appendChild(fig);
      }
      div.appendChild(content);
      section.forEach((el) => content.appendChild(el));
      return div;
    });
    const stepsDiv = document.createElement("div");
    stepsDiv.className = "sk-steps";
    formattedSections.flat().forEach((i) => stepsDiv.appendChild(i));
    return { element: stepsDiv, nextSibling };
  }

  function steps(parent, ingredients, wide = false) {
    const sections = extractSections(parent, STEPS_WORD);
    sections.forEach((section) => {
      const { element: instructionsList, nextSibling } = stepsGroup(section);
      if (instructionsList) {
        if (wide) instructionsList.classList.add("kg-width-wide");
        parent.insertBefore(instructionsList, nextSibling);
        ingredientsInContent(instructionsList, ingredients);
      }
    });
  }

  function metadata(parent) {
    const elements = extractSection(parent, "Metadata");
    const div = document.createElement("div");
    div.className = "sk-metadata";
    elements.forEach((m) => div.appendChild(m));
    return div;
  }

  function accentInspiredByInPostTitle(title) {
    // look for a specific keyword within the title
    // and starting with that keyword, accent the rest of the title
    // by wrapping it in a span with a class
    const keyword = "inspired by";
    
    const titleText = title.innerHTML;
    
    const keywordIndex = ("" + titleText).toLowerCase().indexOf(keyword);
    if (keywordIndex === -1) return;
    const accent = document.createElement("h3");
    accent.className = "sk-accent";
    

    accent.innerText = titleText.slice(keywordIndex);
    title.innerText = titleText.slice(0, keywordIndex);
    
    title.nextSibling
      ? title.parentNode.insertBefore(accent, title.nextSibling)
      : title.parentNode.appendChild(accent);
  }

  function removeInspiredByFromCardTitles() {
    // remove the end of the element's innerHTML after any text that starts with 
    // "inspired by" from all '.gh-feed .gh-card-link .gh-card-title' elements
    const feedCardTitles = document.querySelectorAll(".gh-feed .gh-card-link .gh-card-title");
    feedCardTitles.forEach((title) => {
      const keyword = "inspired by";
      const titleText = title.innerHTML;
      const keywordIndex = ("" + titleText).toLowerCase().indexOf(keyword);
      if (keywordIndex === -1) return;
      title.innerHTML = titleText.slice(0, keywordIndex);
    });
  }

  function mainPost() {
    const main = document.querySelector("main > article.gh-article");
    const body = document.querySelector(".gh-content");
    const header = document.querySelector(".gh-article-header");
    let headerContent;

    if (!main) return;

    const video = heroVideo(body);
    if (video) {
      headerContent = document.createElement("div");
      headerContent.className = "sk-header-content";
      [...header.children].forEach((child) => {
        headerContent.appendChild(child);
      });
      header.appendChild(video);
      header.appendChild(headerContent);
      main.classList.add("sk-has-hero-video");
    }

    const { elements: ingredientsList, ingredients } = ingredientsTable(body);
    const bodyFirst = body.firstChild;

    const ingredientsContainer = document.createElement("div");
    ingredientsContainer.className = "sk-ingredients-container";
    if (video) {
      headerContent.appendChild(ingredientsContainer);
    }

    ingredientsList.forEach((el) => {
      if (video) {
        ingredientsContainer.appendChild(el);
      } else {
        body.insertBefore(el, bodyFirst);
      }
    });

    const serves = servingsChooser(body);
    if (serves) {
      if (video) {
        headerContent.insertBefore(serves, ingredientsContainer);
      } else {
        body.insertBefore(serves, body.firstChild);
      }
    }

    steps(body, ingredients, !!video);

    const meta = metadata(body);
    body.appendChild(meta);

    const title = header.querySelector("h1");
    accentInspiredByInPostTitle(title);
  }

  function convertEquipmentToCarousel() {
    const body = document.querySelector(".gh-content");
    const elements = extractSection(body, "Equipment");
    if (!elements.length) return;
    const equipmentItems = elements.reduce((acc, el) => {
      if (el.tagName === "H3") {
        acc.push({ title: el });
      } else if (el.tagName === "FIGURE") {
        const item = acc[acc.length - 1];
        item.figure = el;
        item.link = el.querySelector("a");
      } else if (el.tagName === "P") {
        const item = acc[acc.length - 1];
        item.description = el;
      }
      return acc;
    }, []);
    const equipmentHeading = extractHeading(body, "Equipment");
    if (!equipmentHeading) return;

    const equipmentDiv = document.createElement("div");
    equipmentDiv.className = "sk-equipment kg-width-wide";
    
    const carouselDiv = document.createElement("div");
    carouselDiv.className = "sk-carousel";
    equipmentDiv.appendChild(carouselDiv);
    const carouselScrollerDiv = document.createElement("div");
    carouselScrollerDiv.className = "sk-carousel-scroller";
    carouselDiv.appendChild(carouselScrollerDiv);
    equipmentItems.forEach((item) => {
      const itemDiv = document.createElement("div");
      itemDiv.className = "sk-carousel-item";
      if (item.link) {
        const children = [...item.link.children];
        children.forEach((child) => {
          item.figure.appendChild(child);
        });
        if (item.figure) {
          // debugger;
          item.link.parentNode.removeChild(item.link);
          item.link.appendChild(item.figure);
        }
        if (item.title) item.link.appendChild(item.title);
        if (item.description) item.link.appendChild(item.description);
        item.link.setAttribute('target', '_blank');
        itemDiv.appendChild(item.link);
      } else {
        if (item.figure) itemDiv.appendChild(item.figure);
        if (item.title) itemDiv.appendChild(item.title);
        if (item.description) itemDiv.appendChild(item.description);
      }
      carouselScrollerDiv.appendChild(itemDiv);
    });
    
    const leftBtn = document.createElement("div");
    leftBtn.className = "sk-carousel-left sk-carousel-button";
    carouselDiv.appendChild(leftBtn);
    const rightBtn = document.createElement("div");
    rightBtn.className = "sk-carousel-right sk-carousel-button";
    carouselDiv.appendChild(rightBtn);

    body.insertBefore(equipmentDiv, equipmentHeading.nextSibling);
    equipmentDiv.insertBefore(equipmentHeading, carouselDiv);

    new Carousel(carouselDiv);
  }

  removeInspiredByFromCardTitles();
  mainPost();
  convertEquipmentToCarousel();
})();
